exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.top-spacer[data-v-13248ddd]{position:absolute;bottom:0;left:0;-webkit-transform:translate(-6%, 15.5px);transform:translate(-6%, 15.5px);width:100vw;height:20px;z-index:5;background-color:#fff\n}", "", {"version":3,"sources":["/newvolume/workspace/Prod/UI/lili-ui-partners-deploy/src/components/welcomeComponents/TopContent.vue"],"names":[],"mappings":";AACA,6BAA6B,kBAAkB,SAAS,OAAO,yCAAyC,iCAAiC,YAAY,YAAY,UAAU,qBAAqB;CAC/L","file":"TopContent.vue","sourcesContent":["\n.top-spacer[data-v-13248ddd]{position:absolute;bottom:0;left:0;-webkit-transform:translate(-6%, 15.5px);transform:translate(-6%, 15.5px);width:100vw;height:20px;z-index:5;background-color:#fff\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13248ddd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/welcomeComponents/TopContent.vue
// module id = XGo3
// module chunks = 27